<template>
  <div>
    <card-toolbar>
      <template #actions>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn id="HsmTlsBundlePage_reset" icon v-on="on">
              <v-icon @click="showConfirmationDialog = true">
                settings_backup_restore
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc("tls_restore") }}</span>
        </v-tooltip>
      </template>
    </card-toolbar>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row no-gutters class="pa-6">
        <v-col cols="12">
          <v-text-field
            id="HsmTlsBundlePage_cert"
            class="mb-6"
            :label="$t('select_cert')"
            v-model="cert"
            @keydown.enter="certSelected()"
            hide-details="auto"
            :error-messages="certErrors"
            :rules="rules"
            @blur="$v.cert.$touch()"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            id="HsmTlsBundlePage_key"
            :label="$t('select_key')"
            v-model="key"
            readonly
            disabled
            hide-details="auto"
            :error-messages="keyErrors"
            @input="$v.key.$touch()"
            @blur="$v.key.$touch()"
          />
        </v-col>

        <v-row justify="end" class="mx-4 mb-4 mt-2">
          <v-btn
            id="HsmTlsBundlePage_setTLSBundle"
            color="green"
            :disabled="$v.$invalid"
            :dark="!$v.$invalid"
            @click="setTlsBundle"
          >
            {{ $t("set_tls_bundle") }}
          </v-btn>
        </v-row>
      </v-row>
    </v-card>

    <confirm-modal
      id="BindDSPage_removeBind_confirm_modal"
      :open="showConfirmationDialog"
      :title="$tc('tls_restore')"
      :message="`${$tc('confirm_tls_restore')}:`"
      :submessage="$tc('tls_info')"
      :positive-btn-title="$t('confirm')"
      @negative="showConfirmationDialog = false"
      @positive="confirmRestore"
    />
  </div>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal.vue'
import { required } from 'vuelidate/lib/validators'
import CardToolbar from '@/components/CardToolbar'

export default {
  components: {
    CardToolbar,
    ConfirmModal
  },
  created () {
    this.loadKeys()
  },
  data () {
    return {
      showConfirmationDialog: false,
      key: null,
      cert: null,
      keys: null,
      message: '',
      rules: [
        value => !(this.objectNameExist(value)) || this.$t('cert_not_exist'),
        value => this.isSingleCert(value) || this.$t('several_certificates_returned')
      ]
    }
  },
  computed: {
    keyErrors () {
      const errors = []
      if (!this.$v.key.$dirty) return errors
      !this.$v.key.required && errors.push(this.$t('$validation.required'))
      return errors
    },
    certErrors () {
      const errors = []
      if (!this.$v.cert.$dirty) return errors
      !this.$v.cert.required && errors.push(this.$t('$validation.required'))
      return errors
    }
  },
  methods: {
    objectNameExist (value) {
      let matchLength = 0
      if (value !== null) {
        matchLength = this.keys.filter(key => key.indexOf(value) > -1).length
      }
      return matchLength < 1
    },
    isSingleCert (value) {
      let matchLength = 0
      if (value !== null) {
        matchLength = this.keys.filter(key => key.indexOf(value) > -1 && key === value).length
      }
      return matchLength === 1
    },
    confirmRestore () {
      this.showConfirmationDialog = false
      this.setTlsBundle()
    },
    loadKeys () {
      // this.loading = true
      this.$store.dispatch('keys/getListKeys').then(res => {
        this.keys = res
      })
    },
    async findPrivateKeyForCert (certId) {
      const certP11Info = await this.$store.dispatch('keys/getP11Manager', {
        obj: certId
      })
      if (certP11Info.HSM_ASSOCIATE === '') {
        this.$notify.error({ message: this.$tc('has_no_linked_key') })
      }
      return certP11Info.HSM_ASSOCIATE
    },
    async certSelected () {
      this.$v.cert.$touch()
      this.key = await this.findPrivateKeyForCert(this.cert)
    },
    async setTlsBundle () {
      const body = {
        key: this.key || '',
        cert: this.cert || ''
      }
      await this.$store.dispatch('hsm/setTlsBundle', { body })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          this.clearForm()
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    }
  },
  validations () {
    const validation = {}
    validation.key = {
      required
    }
    validation.cert = {
      required
    }
    return validation
  }
}
</script>
